
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.429 13.429a.857.857 0 00-.858.857v5.143a.857.857 0 01-.857.857H3.571a.857.857 0 01-.857-.857v-5.143a.857.857 0 10-1.714 0v5.143A2.571 2.571 0 003.571 22h17.143a2.571 2.571 0 002.572-2.571v-5.143a.857.857 0 00-.857-.857z","fill":"#000"}}),_c('path',{attrs:{"d":"M17.015 12.823a.857.857 0 00-1.19 0L13 15.645V2.857a.857.857 0 00-1.715 0v12.788l-2.822-2.822a.857.857 0 00-1.212 1.212l4.286 4.285a.857.857 0 001.212.002l4.287-4.287a.857.857 0 00-.021-1.212z","fill":"#000"}})])
          )
        }
      }
    